import { logError } from 'utils/logger.utils';

const SITEMAP_SUBMITTED_STORAGE_KEY = 'sitemapSubmittedPayload';

export const saveSitemapSubmittedPayload = (payload) => {
  try {
    sessionStorage.setItem(SITEMAP_SUBMITTED_STORAGE_KEY, JSON.stringify(payload));
  } catch (error) {
    // QuotaExceeded / private mode — page still works without persisted payload
    logError('saveSitemapSubmittedPayload failed', { error: error.message });
  }
};

export const readSitemapSubmittedPayload = () => {
  try {
    const raw = sessionStorage.getItem(SITEMAP_SUBMITTED_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    logError('readSitemapSubmittedPayload failed', { error: error.message });
    return null;
  }
};
